import * as React from 'react'
import { SubscriptionContext } from '../../../context'

const useRetention = () => {
  const context = React.useContext(SubscriptionContext)
  if (context === undefined) {
    throw new Error('useRetention must be used within a RetentionProvider')
  }
  return context
}

export { useRetention }
